{
  "comment": "Mission 4 comms (S13 owns). Node shape: src/story/schemas.ts commsNodeSchema (a speaker, 1–3 lines, 1–4 replies; \"Show [log]\" replies; a reply without next ends the conversation). Node ids are unique across every comms file. Voice: docs/story/drafts/2026-09-29-m7-voice-samples.md (Duarte procedural and frightened; Hale reasonable, never threatens, talks in quarters and registries; his offer does real good). Hale's terms follow the rev-2 deal (spec §7): charters for a corporation or the founding fee for a pilot, warrants older than the call, the Holdfast claims. Text placeholders until the naming and voice pass.",
  "nodes": [
    {
      "id": "m4.duarte.offer",
      "speaker": "duarte",
      "lines": [
        "Registry desk. Duarte. You filed a records request; I'm on the break-room line, not the desk.",
        "Your request went into the weekly digest, and the digest goes up to the Commissioner. I pulled it and re-filed it as a hull query. That holds a week, maybe."
      ],
      "replies": [
        { "id": "why", "text": "Why would you do that?", "next": "m4.duarte.why" },
        { "id": "archive", "text": "What's in the archive?", "next": "m4.duarte.archive" },
        { "id": "noask", "text": "I didn't ask you to.", "next": "m4.duarte.noask" }
      ]
    },
    {
      "id": "m4.duarte.why",
      "speaker": "duarte",
      "lines": [
        "My grandmother filed a claim in the dark years. Hab logs, three hundred days of them. It's in a box marked \"pending\".",
        "I stamp other people's claims every day. Hers I'm not cleared to open."
      ],
      "replies": [{ "id": "go", "text": "How do I get in?", "next": "m4.duarte.route" }]
    },
    {
      "id": "m4.duarte.archive",
      "speaker": "duarte",
      "lines": [
        "Sealed stacks, Commission records, the dark years. I can give you the shelf number. I can't tell you what's on it."
      ],
      "replies": [{ "id": "go", "text": "How do I get in?", "next": "m4.duarte.route" }]
    },
    {
      "id": "m4.duarte.noask",
      "speaker": "duarte",
      "lines": ["No. Nobody asked me."],
      "replies": [{ "id": "go", "text": "How do I get in?", "next": "m4.duarte.route" }]
    },
    {
      "id": "m4.duarte.route",
      "speaker": "duarte",
      "lines": [
        "If you go in by the front door, the Commissioner knows by morning.",
        "The Mutual crew that services the archive relay goes in the back every sixth day."
      ],
      "replies": [
        { "id": "thanks", "text": "Thank you." },
        { "id": "exposed", "text": "If this goes wrong, you're the one exposed.", "next": "m4.duarte.exposed" }
      ]
    },
    {
      "id": "m4.duarte.exposed",
      "speaker": "duarte",
      "lines": ["I'm a registry clerk with a Holdfast name. I've been exposed my whole life."],
      "replies": [{ "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m4.records.legal",
      "speaker": "recordsDesk",
      "lines": [
        "Request logged. Fee received. Present your registry at the archive dock for escort to the sealed stacks."
      ],
      "replies": [{ "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m4.relay_crew.back",
      "speaker": "mutualRelayCrew",
      "lines": [
        "Sixth-day slot. Bring the parts on the list and you're a parts tech for the afternoon.",
        "Don't touch anything with a seal on it that you don't mean to carry out."
      ],
      "replies": [{ "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m4.hale.call",
      "speaker": "hale",
      "lines": [
        "Commissioner Hale, Charter Office. Thank you for taking this; I know you're mid-transit.",
        "You have minute 50-A in your hold. The archive logs its requests. I sign the log.",
        "I won't ask for it back. I'd like to make you an offer, and I'd like you to hear all of it."
      ],
      "replies": [{ "id": "listen", "text": "Go on.", "next": "m4.hale.offer" }]
    },
    {
      "id": "m4.hale.offer",
      "speaker": "hale",
      "lines": [
        "If you found a company, the founding fee is waived, and the standing rule with it for the first few charters you file.",
        "The warrants on your registry from before today, closed. Not the ones after. And the Holdfast generational claims, filed in the dark years and never entered, go into the Charter registry.",
        "That file has fed nobody in fifty years. A registry line feeds people by next quarter."
      ],
      "variants": {
        "corporation": [
          "Charters for your company, the standing rule waived and the fees refunded, for the next few you file.",
          "The warrants on your registry from before today, closed. Not the ones after. And the Holdfast generational claims, filed in the dark years and never entered, go into the Charter registry.",
          "That file has fed nobody in fifty years. A registry line feeds people by next quarter."
        ]
      },
      "replies": [
        { "id": "why", "text": "Why did you keep it?", "next": "m4.hale.why" },
        { "id": "file", "text": "And the file?", "next": "m4.hale.file" },
        {
          "id": "clause",
          "text": "Show him what the Settlement signed.",
          "show": { "thread": "settlement", "link": "complicity" },
          "next": "m4.hale.clause"
        },
        { "id": "think", "text": "I'll think about it.", "next": "m4.hale.think" }
      ]
    },
    {
      "id": "m4.hale.why",
      "speaker": "hale",
      "lines": ["Retention is at the reviewing officer's discretion. The log records that it was exercised."],
      "replies": [
        { "id": "ok", "text": "I'll think about it.", "next": "m4.hale.think" },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "m4.hale.file",
      "speaker": "hale",
      "lines": [
        "It comes to my office, not to a shredder. You have my word on that, for whatever you've decided it's worth."
      ],
      "replies": [
        { "id": "ok", "text": "I'll think about it.", "next": "m4.hale.think" },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "m4.hale.clause",
      "speaker": "hale",
      "lines": [
        "You've read what the Settlement signed. It was not drafted in this office. It has been enforced by it for fifty years.",
        "The offer doesn't change. No one else can enter a claim."
      ],
      "replies": [
        { "id": "ok", "text": "I'll think about it.", "next": "m4.hale.think" },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "m4.hale.think",
      "speaker": "hale",
      "lines": [
        "Take a day. The registry closes its quarter soon. After that the Holdfast wait another quarter.",
        "They're good at waiting. I'd rather they didn't have to be."
      ],
      "replies": [{ "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m4.hale.taken",
      "speaker": "hale",
      "lines": [
        "Thank you. The registry entries post at the end of the quarter.",
        "The file comes to my office. Not to a shredder."
      ],
      "replies": [{ "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m4.hale.refused",
      "speaker": "hale",
      "lines": [
        "I understand. The Settlement's registry entry will show \"withdrawn\". Not destroyed. Withdrawn.",
        "I hope the file feeds someone."
      ],
      "replies": [{ "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m4.hale.voided",
      "speaker": "hale",
      "lines": [
        "You've voided our arrangement. The fee waiver lapses, the warrants come back with their interest, and the fee is on your books.",
        "It isn't a punishment. It's the paperwork catching up."
      ],
      "variants": {
        "corporation": [
          "You've voided our arrangement. The charters go to review, the warrants come back with their interest, and the fees are on your books.",
          "It isn't a punishment. It's the paperwork catching up."
        ]
      },
      "replies": [{ "id": "close", "text": "(close the channel)" }]
    }
  ]
}
